import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { CacheService } from '~Services/cache.service';

/**
 * Service de fournisseur
 */
@Injectable({
  providedIn: 'root'
})
export class FournisseurService {

    /**
     * Constructeur
     * @param http
     */
    constructor(private http: HttpClient, private cacheService: CacheService) {
    }

    /**
     * Obtenir un fournisseur par son code
     * @param code
     */
    obtenirFournisseurFAST(code: string): any {
        let httpParams = new HttpParams().set('Code', code);
        let options = {
            params: httpParams
        };
        let reponse = this.http.get(`api/fournisseur/obtenirfournisseurfast`, options).pipe(map(retour => { return retour; }));

        // Mettre en cache 10 secondes
        let cle = `api/fournisseur/obtenirfournisseurfast` + '_code:' + code;
        let duree = 10000;
        return this.cacheService.Obtenir(reponse, cle, duree);
    }

    /**
     * Mettre � jour la photo du fournisseur
     * @param code
     * @param photo
     */
    soumettrePhotoFournisseur(code: string, photoBase64: string) {
        const formData: FormData = new FormData();
        formData.append('Code', code);
        formData.append('PhotoBase64', photoBase64);
        return this.http.put(`api/fournisseur/soumettrephotofournisseur`, formData).pipe(map(retour => { return retour as any; }));
    }

    /**
     * Obtenir les informations sur la photo du fournisseur
     * @param code
     */
    obtenirInformationsPhoto(code: string): any {
        let httpParams = new HttpParams().set('Code', code);
        let options = {
            params: httpParams
        };
        return this.http.get(`api/fournisseur/obtenirinformationsphoto`, options).pipe(map(retour => { return retour; }));
    }

    /**
     * Marquer la photo comme vu
     * @param code
     */
    marquerPhotoVu(code: string): any {
        let httpParams = new HttpParams().set('Code', code);
        let options = {
            params: httpParams
        };
        return this.http.get(`api/fournisseur/marquerphotovu`, options).pipe(map(retour => { return retour; }));
    }
}